type TraceHeadersProvider = () => Record<string, string> | undefined;

let provider: TraceHeadersProvider | undefined;

/** Registered from `main.tsx` after Sentry.init (keeps Sentry out of the prerender bundle). */
export function setSentryTraceHeadersProvider(fn: TraceHeadersProvider) {
	provider = fn;
}

export function getSentryTraceHeaders(): Record<string, string> | undefined {
	if (typeof window === "undefined") {
		return undefined;
	}
	return provider?.();
}
